import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

export function PageBreadcrumb({ current }: { current: string }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="mx-auto max-w-5xl px-6 pt-6 text-xs tracking-wide text-muted-foreground"
    >
      <ol className="flex items-center gap-1.5">
        <li>
          <Link to="/" className="hover:text-gold transition-colors">
            Home
          </Link>
        </li>
        <li aria-hidden="true">
          <ChevronRight className="h-3.5 w-3.5" />
        </li>
        <li aria-current="page" className="text-foreground">
          {current}
        </li>
      </ol>
    </nav>
  );
}
